export const API_ENDPOINT = "https://hiltonglobal.in/wp-json/wp/v2";
export const SENDGRID_API_URL = "https://api.sendgrid.com/v3/mail/send";
export const SENDGRID_API_KEY =
  "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";
export const receivermail = "info@hiltonglobal.in"; //to mail
export const sendermail = "info@hiltonglobal.in"; //from mail
export const recaptchakey = "6LfS-4UqAAAAAKLrTtox7Q0l318MDypFKk_k5qJA";
